import { AbGoals } from '../../utils';
import { SchedulingActions } from './constants';

const {
    CLEAR_BOOKING_ERROR,
    FETCHING_BOOKING_STATE,
    FETCH_BOOKING_STATE_FAILURE,
    FETCH_BOOKING_STATE_SUCCESS,
    RESET_BOOKING_SUBMISSION_STATE,
    SUBMITTING_BOOKING,
    SUBMIT_BOOKING_FAILURE,
    SUBMIT_BOOKING_SUCCESS,
    UPDATE_BOOKING_REQUIREMENT_VALUE,
    UPDATE_BOOKING_STATE_FAILURE,
    UPDATE_BOOKING_STATE_SUCCESS,
    UPDATE_LOCAL_BOOKING_STATE,
    UPDATING_BOOKING_STATE,
} = SchedulingActions;

export const resetAsyncState = () => ({
    type: RESET_BOOKING_SUBMISSION_STATE,
});

export const updatingBookingState = () => ({
    type: UPDATING_BOOKING_STATE,
});

export const updateLocalBookingState = (bookingState) => ({
    type: UPDATE_LOCAL_BOOKING_STATE,
    bookingState,
});

export const updateBookingStateSuccess = (bookingState) => ({
    type: UPDATE_BOOKING_STATE_SUCCESS,
    bookingState,
});

export const updateBookingStateFailure = (errorFields) => ({
    type: UPDATE_BOOKING_STATE_FAILURE,
    errorFields,
});

export const gettingBookingState = () => ({
    type: FETCHING_BOOKING_STATE,
});

export const getBookingStateSuccess = (bookingState) => ({
    type: FETCH_BOOKING_STATE_SUCCESS,
    bookingState,
});

export const getBookingStateFailure = () => ({
    type: FETCH_BOOKING_STATE_FAILURE,
});

export const clearBookingError = () => ({
    type: CLEAR_BOOKING_ERROR,
});

export const submittingBooking = () => ({
    type: SUBMITTING_BOOKING,
    _abGoal: AbGoals.ClickedBook,
});

export const submitBookingSuccess = (bookingState) => ({
    type: SUBMIT_BOOKING_SUCCESS,
    bookingState,
});

export const submitBookingFailure = ({
    bookingErrors,
    bookingErrorCode,
} = {}) => ({
    type: SUBMIT_BOOKING_FAILURE,
    bookingErrors,
    bookingErrorCode,
});

export const updateBookingRequirementValue = (key, value) => ({
    type: UPDATE_BOOKING_REQUIREMENT_VALUE,
    key,
    value,
});
